import styled from 'styled-components';
import { DialogContent } from '@mui/material';
import Select from 'react-select';
import { Styling, Colors } from '../../../../constants';

export const selectClassPrefix = 'ShareDialogSelect';
const menuOptionHeight = 30;

export const ShareDialogContent = styled(DialogContent)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: ${menuOptionHeight * 9}px;
  & > div {
    width: 420px;
  }
`;

export const StyledSelect = styled(Select)`
  margin-top: ${Styling.DEFAULT_SPACING}px;
  div.${selectClassPrefix}__control {
    padding: ${Styling.DEFAULT_SPACING_HALVED}px;
    &.${selectClassPrefix}__control--is-focused {
      border: 1px solid ${Colors.RED_1};
      box-shadow: none;
    }
    &.${selectClassPrefix}__control--menu-is-open {
      max-height: ${menuOptionHeight * 2.5}px;
      overflow-y: scroll;
      div.${selectClassPrefix}__indicators {
        max-height: ${menuOptionHeight}px;
        div.${selectClassPrefix}__dropdown-indicator,
        span.${selectClassPrefix}__indicator-separator {
          display: none !important;
        }
      }
      div.${selectClassPrefix}__value-container {
        div.${selectClassPrefix}__multi-value {
          background-color: ${Colors.PRIMARY_75};
          div.${selectClassPrefix}__multi-value__label,
          div.${selectClassPrefix}__multi-value__remove {
            color: ${Colors.WHITE_100};
          }
        }
      }
    }
  }
  div.${selectClassPrefix}__menu {
    position: relative;
    div.${selectClassPrefix}__menu-list {
      height: ${menuOptionHeight * 5}px;
    }
    div.${selectClassPrefix}__option {
      height: ${menuOptionHeight}px;
      &.${selectClassPrefix}__option--is-focused {
        background-color: ${Colors.PRIMARY_5};
      }
    }
  }
`;
